export const dashboardTheme = {
  animation: {
    transition: ".3s ease"
  },

  topBar: {
    backgroundColor: "white"
  },

  sidebar: {
    width: 80,
    backgroundColor: "gray.700",
    fontColor: "gray.200",
    borderColor: "gray.300",
    headerColor: "gray.100",
    dividerColor: "gray.600"
  },

  sidebarLink: {
    base: {
      backgroundColor: "gray.700",
      textColor: "gray.200"
    },
    hovered: {
      backgroundColor: "gray.800",
      textColor: "gray.200"
    },
    selected: {
      backgroundColor: "gray.900",
      textColor: "white"
    }
  },

  page: {
    backgroundColor: "gray.50"
  },

  tab: {
    hovered: {
      backgroundColor: "gray.700"
    },
    selected: {
      backgroundColor: "gray.600"
    }
  }
};
